var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGammingHeadshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95859 0.292969C9.56797 -0.0976562 8.93359 -0.0976562 8.54297 0.292969L4.79297 4.04297C4.40234 4.43359 4.40234 5.06797 4.79297 5.45859L5.29297 5.95859C5.68359 6.34922 6.31797 6.34922 6.70859 5.95859L6.83359 5.83359L10.1711 9.16797L10.0461 9.29297C9.65547 9.68359 9.65547 10.318 10.0461 10.7086L10.5461 11.2086C10.9367 11.5992 11.5711 11.5992 11.9617 11.2086L15.7117 7.45859C16.1023 7.06797 16.1023 6.43359 15.7117 6.04297L15.2117 5.54297C14.8211 5.15234 14.1867 5.15234 13.7961 5.54297L13.6711 5.66797L10.3336 2.33047L10.4586 2.20547C10.8492 1.81484 10.8492 1.18047 10.4586 0.789844L9.95859 0.289844V0.292969ZM5.20859 9.29297C4.81797 8.90234 4.18359 8.90234 3.79297 9.29297L0.292969 12.793C-0.0976562 13.1836 -0.0976562 13.818 0.292969 14.2086L1.79297 15.7086C2.18359 16.0992 2.81797 16.0992 3.20859 15.7086L6.70859 12.2086C7.09922 11.818 7.09922 11.1836 6.70859 10.793L6.66484 10.7492L8.50234 8.91484L7.08672 7.49922L5.25234 9.33359L5.20859 9.28984V9.29297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGammingHeadshot);
export default __webpack_public_path__ + "static/media/gamming-headshot.bec6f4ba1fd4af5f179c25e9dd407983.svg";
export { ForwardRef as ReactComponent };